import { render, staticRenderFns } from "./_index.vue?vue&type=template&id=bb82998e&"
import script from "./_index.vue?vue&type=script&lang=js&"
export * from "./_index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports